module.exports = __webpack_public_path__ + "static/media/ear_animation.38c8480f.gif";